<template>
  <div class="px-5">
    <v-container grid-list-xl fluid class="px-0 pl-1">
      <v-layout row wrap class="pr-5 pl-2">
        <v-flex class="py-0">
          <h2 class="primary--text breadcrumbs fs-16 lh-29 font-weight-700">
            Budget Report
          </h2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-breadcrumbs
          class="px-0 fs-12 lh-15 py-0 breadcrumbs-items custom-breadcrumbs"
          :items="breadcrumbs"
        ></v-breadcrumbs>
      </v-layout>

      <v-card class="rounded-10 elevation-card mt-5 mx-2">
        <v-card-title class="primary py-3 px-5 white--text">
          <span
            class="font-weight-600 fs-16 lh-16 pl-1"
            style="align-self: center"
          >
            ADD/CUT BUDGET
          </span>
        </v-card-title>

        <v-flex xs12 class="px-5 mt-5">
          <label class="darkblue--text fs-12">Year</label> <br />
          <date-picker
            v-model="year"
            type="year"
            placeholder="Year"
            format="YYYY"
            class="dashSearch filterSearch"
            style="width: 135px !important;"
          />
        </v-flex>
        <v-flex xs12 class="px-5 mt-2">
          <label class="darkblue--text fs-12">Budget Owner</label>
          <v-autocomplete
            multiple
            id="ownerId"
            single-line
            outlined
            dense
            label="Select Budget Owner"
            v-model="budget_owners"
            required
            :items="itemsBO"
            item-text="desc"
            item-value="id"
            autocomplete
            hide-details
          ></v-autocomplete>
          <v-btn
            class="thirdblue white--text mt-2"
            @click="getTemplate()"
            id="downloadButton"
            >Download Template</v-btn
          >
        </v-flex>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="confirmSubmit" id="formBudget">
            <v-card-text class="px-5 pt-5 mt-5">
              <v-flex xs12>
                <label class="darkblue--text font-weight-600">
                  Upload Add/Cut Budget
                </label>
                <vue-dropzone
                  :use-font-awesome="true"
                  ref="myVueDropzone"
                  id="dropzone"
                  :options="dropzoneOptions"
                  @vdropzone-complete="afterComplete"
                ></vue-dropzone>

                <v-btn
                  class="secondblue mt-3 white--text"
                  block
                  :disabled="isDisabled"
                  @click="parseFile"
                  id="convertButton"
                  >Convert File to Table</v-btn
                >
              </v-flex>
              <hr class="hr-line" style="" />
              <v-layout row wrap class="px-3" v-if="isVisible">
                <span class="font-weight-medium subtitle-1 darkblue--text"
                  >Converted File
                </span>
                <span
                  class="body-2 font-weight-light secondblue--text pt-1 pl-2"
                  id="nameFile"
                >
                  [[ {{ nameFile }} ]]</span
                >
                <v-col sm="12" class="px-0">
                  <template>
                    <v-simple-table
                      fixed-header
                      class="table-converted nav-table"
                      id="convertedTable"
                      height="300px"
                    >
                      <template v-slot:default>
                        <!-- <VuePerfectScrollbar
                          class="drawer-menu--scroll"
                          :settings="scrollSettings"
                        > -->
                        <thead>
                          <tr class="primary">
                            <th class="f-14" width="7%">
                              Year
                            </th>
                            <th class="f-14">
                              Budget Owner
                            </th>
                            <th class="f-14">
                              Taxonomy
                            </th>
                            <th class="f-14">
                              Description
                            </th>
                            <th class="f-14">
                              Current Budget
                            </th>
                            <th class="f-14">
                              Add/Cut Amount
                            </th>
                            <th class="f-14" width="10%">
                              Type
                            </th>
                            <th class="f-14">Reason</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in itemsConvert" :key="item.amount">
                            <td class="fs-12" width="7%">
                              {{ item.year ? item.year : '-' }}
                            </td>
                            <td class="fs-12">
                              {{ item.budgetOwner ? item.budgetOwner : '-' }}
                            </td>
                            <td class="fs-12">
                              {{ item.taxonomy ? item.taxonomy : '-' }}
                            </td>
                            <td class="fs-12">
                              {{ item.description ? item.description : '-' }}
                            </td>
                            <td class="fs-12 text-right">
                              {{ item.budget ? idr(item.budget) : '-' }}
                            </td>
                            <td class="fs-12 text-right">
                              {{ item.amount ? idr(item.amount) : '-' }}
                            </td>
                            <td class="fs-12 text-uppercase" width="10%">
                              {{ item.type ? item.type : '-' }}
                            </td>
                            <td class="fs-12">
                              {{ item.reason ? item.reason : '-' }}
                            </td>
                          </tr>
                        </tbody>
                        <!-- </VuePerfectScrollbar> -->
                      </template>
                    </v-simple-table>
                  </template>
                  <hr class="hr-line mb-5 mt-5" style="" />
                </v-col>
              </v-layout>
            </v-card-text>
            <v-card-actions class="pa-0 pb-5 pr-5">
              <v-spacer></v-spacer>
              <v-btn
                :to="{ name: 'budgeting-report' }"
                class="grey darken-1 white--text"
                id="cancelBudget"
                >Cancel</v-btn
              >
              <v-btn
                type="submit"
                class="primary white--text"
                :disabled="!isSave"
                id="saveBudget"
                >Submit</v-btn
              >
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <v-dialog v-model="dialogError" scrollable max-width="600px">
      <v-card class="py-3 pb-5">
        <v-flex class="text-center">
          <div
            class="swal2-icon swal2-error swal2-animate-error-icon"
            style="display: flex;"
          >
            <span class="swal2-x-mark">
              <span class="swal2-x-mark-line-left"></span>
              <span class="swal2-x-mark-line-right"></span>
            </span>
          </div>
          <h2 class="swal2-title" id="swal2-title">Failed!</h2>
          <p></p>
        </v-flex>
        <div class="swal2-content">
          <div id="swal2-content" style="display: block;">
            {{ budgetError.message }}
          </div>
        </div>
        <v-expansion-panels
          flat
          class="filterby-info mt-1"
          v-if="budgetError.dataError"
          v-model="panelListError"
        >
          <v-expansion-panel>
            <v-expansion-panel-header
              class="primary--text fs-14 d-block text-center"
              height="100px"
            >
              {{ panelListError === 0 ? 'Hide' : 'Show' }} Error List
            </v-expansion-panel-header>
            <v-expansion-panel-content class="grey--text">
              <v-simple-table class="spending-table nav-table px-8 mt-5">
                <template v-slot:default>
                  <thead>
                    <tr class="primary custom-table-header">
                      <th class="f-14 font-weight-500">
                        Budget Owner
                      </th>
                      <th class="f-14 font-weight-500">Taxonomy</th>
                      <th class="f-14 font-weight-500">Error</th>
                    </tr>
                  </thead>
                  <v-perfect-scroll
                    class="drawer-menu--scroll-error"
                    :settings="scrollSettingsError"
                  >
                    <tbody v-if="budgetError.dataError.length > 0">
                      <tr
                        v-for="(item, index) in budgetError.dataError"
                        :key="'bo' + index"
                      >
                        <td class="fs-12">
                          {{ item.budgetOwner }}
                        </td>
                        <td class="fs-12">
                          {{ item.taxonomy }}
                        </td>
                        <td class="fs-12">
                          {{ item.error }}
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="4" class="text-center pt-2">
                          <span>No Data Displayed</span>
                        </td>
                      </tr>
                    </tbody>
                  </v-perfect-scroll>
                </template>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div class="swal2-actions">
          <button
            type="button"
            class="swal2-confirm swal2-styled"
            style="display: inline-block; border-left-color: rgb(48, 133, 214); border-right-color: rgb(48, 133, 214);"
            @click="dialogError = false"
          >
            OK
          </button>
        </div>
      </v-card>
    </v-dialog>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '@/components/progress_dialog';
import Swal from 'sweetalert2';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import ACLMixin from '@/mixins/ACLMixin';
// import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moment from 'moment';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    vueDropzone: vue2Dropzone
    // VuePerfectScrollbar
  },
  mixins: [ACLMixin],
  data() {
    return {
      scrollSettings: {
        maxScrollbarLength: 260
      },
      scrollSettingsError: {
        maxScrollbarLength: 100
      },
      isDisabled: true,
      loading: false,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        acceptedFiles: '.xlsx',
        maxFiles: 1,
        init: function() {
          this.on('addedfile', function() {
            if (this.files.length > 1) {
              this.removeFile(this.files[0]);
            }
          });
        },
        addRemoveLinks: true,
        dictDefaultMessage:
          '<i class="fas fa-camera"></i><span class="primary--text">Click or Drop Files Here to Upload</span>'
      },
      progressDialogLoading: false,
      isVisible: false,
      isSave: false,
      xlxFile: {},
      nameFile: '',
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      breadcrumbs: [
        {
          text: 'BUDGETING',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'BUDGET REPORT',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: 'ADD/CUT BUDGET',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      itemsConvert: [],
      baseUrl: process.env.VUE_APP_BASE_URL,
      itemsBO: [],
      budget_owners: [],
      year: new Date(),
      dialogError: false,
      panelListError: null,
      budgetError: {
        message: '',
        dataError: []
      }
    };
  },
  async mounted() {
    this.progressDialogLoading = true;
    await this.getBO();
  },
  methods: {
    getBO() {
      this.progressDialogLoading = true;
      return this.$store
        .dispatch('budget/getOwner')
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.itemsBO = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
        });
    },
    afterComplete(file) {
      this.isDisabled = false;
      this.xlxFile = file;
      this.nameFile = file.upload.filename;
    },
    parseFile() {
      var fileType = this.nameFile.split('.').pop();
      var fileTypes = ['xlsx', 'xls', 'XLS', 'XLSX'];
      if (fileTypes.includes(fileType)) {
        this.progressDialogLoading = true;
        this.isVisible = false;
        this.itemsConvert = [];
        let formData = new FormData();
        formData.append('budgetMovement', this.xlxFile);
        this.$store
          .dispatch('budgetDynamic/parseAddCutBudget', formData)
          .then(data => {
            this.progressDialogLoading = false;
            if (data.code === 200) {
              Swal.fire('Success!', data.message.text_en, 'success');
              this.itemsConvert = data.data;
              this.isDisabled = true;
              this.isVisible = true;
              this.isSave = true;
            } else {
              this.isSave = false;
              if (data) {
                this.dialogErrorParse(data.response.data);
              } else {
                Swal.fire('Failed!', 'Please try again', 'error');
              }
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        Swal.fire('Failed!', 'Format file must be .xlsx', 'error');
        this.$refs.myVueDropzone.removeAllFiles();
      }
    },
    dialogErrorParse(data) {
      this.budgetError.message = data.message.text_en;
      if (data.data) {
        this.budgetError.dataError = data.data.dataError;
      } else {
        this.budgetError.dataError = [];
      }
      this.dialogError = true;
    },
    confirmSubmit() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to submit this data?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.save();
        }
      });
    },
    save() {
      const validated = this.$refs.obs.validate();

      if (validated) {
        this.progressDialogLoading = true;
        let payload = {
          data: this.itemsConvert
        };
        this.$store
          .dispatch('budgetDynamic/submitAddCutBudget', payload)
          .then(data => {
            this.progressDialogLoading = false;
            if (data.code === 200) {
              Swal.fire('Success!', data.message.text_en, 'success');
              this.$router.push({
                name: 'budgeting-report'
              });
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      }
    },
    getTemplate() {
      window.open(
        this.baseUrl +
          '/v2/budget/movement/template?budget_owner_ids=' +
          this.budget_owners +
          '&year=' +
          moment(this.year).format('YYYY') +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    }
  }
};
</script>
<style scoped lang="css">
.hr-line {
  margin-bottom: 10px;
  margin-top: 20px;
  border: 1px solid #d8d8d8;
}
.drawer-menu--scroll {
  max-height: 300px;
  overflow: auto;
}
.drawer-menu--scroll-error {
  max-height: 135px;
  overflow: auto;
}
</style>
